import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";
import Avatar from "@mui/material/Avatar";
import colors from "assets/theme/base/colors";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import { StoreContext } from "context/store";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "services/api";

const ConnectionCard = ({}) => {
  const { store } = useContext(StoreContext);
  const [counts, setCounts] = useState({});

  const loadData = async () => {
    const { data } = await api.social.getcount();
    setCounts(data);
  };

  useEffect(() => {
    loadData();
  }, []);

  //console.log('counts', counts)
  return (
    <SuiBox>
      <SuiBox sx={{ border: `${colors.secondary.main} solid 2px`, borderRadius: "8px", p: 1 }}>
        <SuiTypography variant="h6" fontWeight="bold" textTransform="none">
          Manage my connections
        </SuiTypography>
        <SuiBox my={1} mb={2}>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" px={1} mb={1}>
            <SuiTypography
              variant="body1"
              fontWeight="regular"
              textTransform="capitalize"
              component={Link}
              to="/connect/followers"
            >
              <PeopleAltOutlinedIcon
                sx={{ mr: 1, verticalAlign: "middle", width: 26, height: 26 }}
              />
              followers
            </SuiTypography>
            <SuiTypography variant="body1" fontWeight="regular" textTransform="capitalize">
              {counts.followerscount}
            </SuiTypography>
          </SuiBox>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" px={1} mb={1}>
            <SuiTypography
              variant="body1"
              fontWeight="regular"
              textTransform="capitalize"
              component={Link}
              to="/connect/following"
            >
              <PermContactCalendarOutlinedIcon
                sx={{ mr: 1, verticalAlign: "middle", width: 26, height: 26 }}
              />
              following
            </SuiTypography>
            <SuiTypography variant="body1" fontWeight="regular" textTransform="capitalize">
              {counts.followingcount}
            </SuiTypography>
          </SuiBox>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" px={1} mb={1}>
            <SuiTypography
              variant="body1"
              fontWeight="regular"
              textTransform="capitalize"
              component={Link}
              to="/connect/collaborators"
            >
              <GroupsOutlinedIcon sx={{ mr: 1, verticalAlign: "middle", width: 26, height: 26 }} />
              collaborators
            </SuiTypography>
            <SuiTypography variant="body1" fontWeight="regular" textTransform="capitalize">
              {counts.collaboratorscount}
            </SuiTypography>
          </SuiBox>
          {false && (
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" px={1} mb={1}>
              <SuiTypography
                variant="body1"
                fontWeight="regular"
                textTransform="capitalize"
                component={Link}
                to="/connect/events"
              >
                <CalendarMonthOutlinedIcon
                  sx={{ mr: 1, verticalAlign: "middle", width: 26, height: 26 }}
                />
                events
              </SuiTypography>
              <SuiTypography variant="body1" fontWeight="regular" textTransform="capitalize">
                12
              </SuiTypography>
            </SuiBox>
          )}
        </SuiBox>

        <SuiBox sx={{ borderTop: `${colors.secondary.main} solid 2px`, height: 2, p: 1 }} />
        <SuiBox sx={{ my: 1, px: 1 }}>
          <SuiBox display="flex" alignItems="center" gap={1}>
            <Avatar
              src={store?.metadata?.avatar}
              sx={{
                width: 46,
                height: 46,
              }}
            />
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Invite your contacts to join UpStyled
            </SuiTypography>
          </SuiBox>
          <SuiTypography
            variant="body1"
            fontWeight="regular"
            textTransform="none"
            lineHeight={1.4}
            sx={{ my: 1 }}
          >
            Add some familar faces to your network by sending them an invitation to join the
            UpStyled community.
          </SuiTypography>
          <SuiBox sx={{ width: "100%", textAlign: "center" }}>
            <SuiInput type="email" />
            <SuiButton circular color="secondary" variant="contained" size="small" sx={{ my: 1 }}>
              send
            </SuiButton>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
};

export default ConnectionCard;
